import React, { useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import { useGetAllPractitionersQuery } from '@@/services/user';
import MultiSelectInput from '@@/components/Inputs/MultiSelectInput';

const SelectPractitionerInput: React.FC<{
  id: string;
  label?: string;
  placeholder?: string;
  error?: FieldError;
  disabled?: boolean;
  isMulti?: boolean;
  values?: { id: string; label: string }[];
  control: any;
}> = ({
  id,
  label,
  placeholder,
  error,
  disabled,
  isMulti,
  values,
  control,
}) => {
  const { data: practitioners } = useGetAllPractitionersQuery();

  const selectPractionersInput = useMemo(() => {
    if (practitioners) {
      return [...practitioners]
        .map((patient) => ({
          id: patient.id,
          label: `${patient.lastName.toUpperCase()} ${patient.firstName}`,
        }))
        .sort((c1, c2) => {
          if (c1.label < c2.label) {
            return -1;
          }

          if (c1.label > c2.label) {
            return 1;
          }

          return 0;
        });
    }

    return [];
  }, [practitioners]);

  if (!practitioners) {
    return null;
  }

  return (
    <MultiSelectInput
      control={control}
      id={id}
      values={values}
      label={label}
      placeholder={placeholder}
      error={error}
      options={selectPractionersInput}
      isMulti={!!isMulti}
      isDisabled={!!disabled}
    />
  );
};

export default SelectPractitionerInput;
